/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FspPaymentProcessDTO,
  FspPaymentProcessIdentifier,
  FspPaymentProcessImportDTO,
  GetProcessParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get all FSP payment processes
 * @summary Get all processes
 */
export const getAllProcesses = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspPaymentProcessDTO[]>(
      {url: `/frontend/admin/fsp-payment-processes`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllProcessesInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/admin/fsp-payment-processes`
    ] as const;
    }

export const getGetAllProcessesQueryKey = () => {
    return [
    `/frontend/admin/fsp-payment-processes`
    ] as const;
    }

    
export const getGetAllProcessesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllProcesses>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProcessesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProcesses>>> = ({ signal }) => getAllProcesses(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProcessesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllProcesses>>>
export type GetAllProcessesInfiniteQueryError = unknown


export function useGetAllProcessesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProcesses>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProcesses>>,
          TError,
          Awaited<ReturnType<typeof getAllProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProcessesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProcesses>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProcesses>>,
          TError,
          Awaited<ReturnType<typeof getAllProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProcessesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProcesses>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all processes
 */

export function useGetAllProcessesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProcesses>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProcessesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllProcessesQueryOptions = <TData = Awaited<ReturnType<typeof getAllProcesses>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProcessesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProcesses>>> = ({ signal }) => getAllProcesses(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProcessesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllProcesses>>>
export type GetAllProcessesQueryError = unknown


export function useGetAllProcesses<TData = Awaited<ReturnType<typeof getAllProcesses>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProcesses>>,
          TError,
          Awaited<ReturnType<typeof getAllProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProcesses<TData = Awaited<ReturnType<typeof getAllProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProcesses>>,
          TError,
          Awaited<ReturnType<typeof getAllProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProcesses<TData = Awaited<ReturnType<typeof getAllProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all processes
 */

export function useGetAllProcesses<TData = Awaited<ReturnType<typeof getAllProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProcessesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update an existing FSP payment process
 * @summary Update process
 */
export const updateProcess = (
    fspPaymentProcessDTO: FspPaymentProcessDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<FspPaymentProcessDTO>(
      {url: `/frontend/admin/fsp-payment-processes`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fspPaymentProcessDTO
    },
      options);
    }
  


export const getUpdateProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProcess>>, TError,{data: FspPaymentProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProcess>>, TError,{data: FspPaymentProcessDTO}, TContext> => {

const mutationKey = ['updateProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProcess>>, {data: FspPaymentProcessDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateProcess(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProcessMutationResult = NonNullable<Awaited<ReturnType<typeof updateProcess>>>
    export type UpdateProcessMutationBody = FspPaymentProcessDTO
    export type UpdateProcessMutationError = unknown

    /**
 * @summary Update process
 */
export const useUpdateProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProcess>>, TError,{data: FspPaymentProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProcess>>,
        TError,
        {data: FspPaymentProcessDTO},
        TContext
      > => {

      const mutationOptions = getUpdateProcessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create a new FSP payment process
 * @summary Create process
 */
export const createProcess = (
    fspPaymentProcessDTO: FspPaymentProcessDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspPaymentProcessDTO>(
      {url: `/frontend/admin/fsp-payment-processes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fspPaymentProcessDTO, signal
    },
      options);
    }
  


export const getCreateProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProcess>>, TError,{data: FspPaymentProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProcess>>, TError,{data: FspPaymentProcessDTO}, TContext> => {

const mutationKey = ['createProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProcess>>, {data: FspPaymentProcessDTO}> = (props) => {
          const {data} = props ?? {};

          return  createProcess(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProcessMutationResult = NonNullable<Awaited<ReturnType<typeof createProcess>>>
    export type CreateProcessMutationBody = FspPaymentProcessDTO
    export type CreateProcessMutationError = unknown

    /**
 * @summary Create process
 */
export const useCreateProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProcess>>, TError,{data: FspPaymentProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProcess>>,
        TError,
        {data: FspPaymentProcessDTO},
        TContext
      > => {

      const mutationOptions = getCreateProcessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete an FSP payment process
 * @summary Delete process
 */
export const deleteProcess = (
    fspPaymentProcessIdentifier: FspPaymentProcessIdentifier,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/frontend/admin/fsp-payment-processes`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: fspPaymentProcessIdentifier
    },
      options);
    }
  


export const getDeleteProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcess>>, TError,{data: FspPaymentProcessIdentifier}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProcess>>, TError,{data: FspPaymentProcessIdentifier}, TContext> => {

const mutationKey = ['deleteProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProcess>>, {data: FspPaymentProcessIdentifier}> = (props) => {
          const {data} = props ?? {};

          return  deleteProcess(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProcessMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProcess>>>
    export type DeleteProcessMutationBody = FspPaymentProcessIdentifier
    export type DeleteProcessMutationError = unknown

    /**
 * @summary Delete process
 */
export const useDeleteProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProcess>>, TError,{data: FspPaymentProcessIdentifier}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProcess>>,
        TError,
        {data: FspPaymentProcessIdentifier},
        TContext
      > => {

      const mutationOptions = getDeleteProcessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Import FSP payment processes
 * @summary Import processes
 */
export const importProcesses = (
    fspPaymentProcessImportDTO: FspPaymentProcessImportDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspPaymentProcessDTO[]>(
      {url: `/frontend/admin/fsp-payment-processes/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fspPaymentProcessImportDTO, signal
    },
      options);
    }
  


export const getImportProcessesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProcesses>>, TError,{data: FspPaymentProcessImportDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importProcesses>>, TError,{data: FspPaymentProcessImportDTO}, TContext> => {

const mutationKey = ['importProcesses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importProcesses>>, {data: FspPaymentProcessImportDTO}> = (props) => {
          const {data} = props ?? {};

          return  importProcesses(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportProcessesMutationResult = NonNullable<Awaited<ReturnType<typeof importProcesses>>>
    export type ImportProcessesMutationBody = FspPaymentProcessImportDTO
    export type ImportProcessesMutationError = unknown

    /**
 * @summary Import processes
 */
export const useImportProcesses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProcesses>>, TError,{data: FspPaymentProcessImportDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importProcesses>>,
        TError,
        {data: FspPaymentProcessImportDTO},
        TContext
      > => {

      const mutationOptions = getImportProcessesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get a specific FSP payment process by identifier
 * @summary Get process
 */
export const getProcess = (
    params: GetProcessParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspPaymentProcessDTO>(
      {url: `/frontend/admin/fsp-payment-processes/process`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetProcessInfiniteQueryKey = (params?: GetProcessParams,) => {
    return [
    'infinite', `/frontend/admin/fsp-payment-processes/process`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetProcessQueryKey = (params?: GetProcessParams,) => {
    return [
    `/frontend/admin/fsp-payment-processes/process`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetProcessInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProcess>>>, TError = unknown>(params: GetProcessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcess>>> = ({ signal }) => getProcess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProcessInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProcess>>>
export type GetProcessInfiniteQueryError = unknown


export function useGetProcessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcess>>>, TError = unknown>(
 params: GetProcessParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcess>>,
          TError,
          Awaited<ReturnType<typeof getProcess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcess>>>, TError = unknown>(
 params: GetProcessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcess>>,
          TError,
          Awaited<ReturnType<typeof getProcess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcess>>>, TError = unknown>(
 params: GetProcessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get process
 */

export function useGetProcessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcess>>>, TError = unknown>(
 params: GetProcessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProcessInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProcessQueryOptions = <TData = Awaited<ReturnType<typeof getProcess>>, TError = unknown>(params: GetProcessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcess>>> = ({ signal }) => getProcess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProcessQueryResult = NonNullable<Awaited<ReturnType<typeof getProcess>>>
export type GetProcessQueryError = unknown


export function useGetProcess<TData = Awaited<ReturnType<typeof getProcess>>, TError = unknown>(
 params: GetProcessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcess>>,
          TError,
          Awaited<ReturnType<typeof getProcess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcess<TData = Awaited<ReturnType<typeof getProcess>>, TError = unknown>(
 params: GetProcessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcess>>,
          TError,
          Awaited<ReturnType<typeof getProcess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcess<TData = Awaited<ReturnType<typeof getProcess>>, TError = unknown>(
 params: GetProcessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get process
 */

export function useGetProcess<TData = Awaited<ReturnType<typeof getProcess>>, TError = unknown>(
 params: GetProcessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProcessQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get payment processes for a specific FSP
 * @summary Get processes by FSP
 */
export const getProcessesByFsp = (
    fspCode: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspPaymentProcessDTO[]>(
      {url: `/frontend/admin/fsp-payment-processes/fsp/${fspCode}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProcessesByFspInfiniteQueryKey = (fspCode?: string,) => {
    return [
    'infinite', `/frontend/admin/fsp-payment-processes/fsp/${fspCode}`
    ] as const;
    }

export const getGetProcessesByFspQueryKey = (fspCode?: string,) => {
    return [
    `/frontend/admin/fsp-payment-processes/fsp/${fspCode}`
    ] as const;
    }

    
export const getGetProcessesByFspInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProcessesByFsp>>>, TError = unknown>(fspCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessesByFspInfiniteQueryKey(fspCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessesByFsp>>> = ({ signal }) => getProcessesByFsp(fspCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fspCode), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProcessesByFspInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessesByFsp>>>
export type GetProcessesByFspInfiniteQueryError = unknown


export function useGetProcessesByFspInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcessesByFsp>>>, TError = unknown>(
 fspCode: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesByFsp>>,
          TError,
          Awaited<ReturnType<typeof getProcessesByFsp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcessesByFspInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcessesByFsp>>>, TError = unknown>(
 fspCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesByFsp>>,
          TError,
          Awaited<ReturnType<typeof getProcessesByFsp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcessesByFspInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcessesByFsp>>>, TError = unknown>(
 fspCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get processes by FSP
 */

export function useGetProcessesByFspInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProcessesByFsp>>>, TError = unknown>(
 fspCode: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProcessesByFspInfiniteQueryOptions(fspCode,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProcessesByFspQueryOptions = <TData = Awaited<ReturnType<typeof getProcessesByFsp>>, TError = unknown>(fspCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProcessesByFspQueryKey(fspCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProcessesByFsp>>> = ({ signal }) => getProcessesByFsp(fspCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fspCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProcessesByFspQueryResult = NonNullable<Awaited<ReturnType<typeof getProcessesByFsp>>>
export type GetProcessesByFspQueryError = unknown


export function useGetProcessesByFsp<TData = Awaited<ReturnType<typeof getProcessesByFsp>>, TError = unknown>(
 fspCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesByFsp>>,
          TError,
          Awaited<ReturnType<typeof getProcessesByFsp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcessesByFsp<TData = Awaited<ReturnType<typeof getProcessesByFsp>>, TError = unknown>(
 fspCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProcessesByFsp>>,
          TError,
          Awaited<ReturnType<typeof getProcessesByFsp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProcessesByFsp<TData = Awaited<ReturnType<typeof getProcessesByFsp>>, TError = unknown>(
 fspCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get processes by FSP
 */

export function useGetProcessesByFsp<TData = Awaited<ReturnType<typeof getProcessesByFsp>>, TError = unknown>(
 fspCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProcessesByFsp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProcessesByFspQueryOptions(fspCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




